import { querySuiteExecutions } from '@/features/executions/data';
import type { GridQueryInput } from '@/ui/composites/grid/gridUtils';
import type { QueryResult, SuiteExecutionDto } from '@flowqa/shared';

export const fetchSuiteExecutionsGrid = async (
  input: GridQueryInput,
  projectId?: string | null,
  organisationId?: string | null,
): Promise<QueryResult<SuiteExecutionDto>> => {
  return await querySuiteExecutions(projectId ?? undefined, organisationId ?? undefined, {
    ...input,
    include: {
      suite: true,
    },
    includeSummary: false,
  });
};
